

















































































































import {
  initPagination,
  Pagination,
  updatePagination
} from '@/types/Pagination';
import { initTableSortAndFilter, updateTableSort, TableSortAndFilter } from '@/types/TableSortAndFilter';
import {
  DealerListDetailResponse,
  DealerListRequest,
  DealerListResponse,
  DealerResponse,
  initForm,
  resetForm,
  updateForm
} from '@/types/api/DealerList';
import SortableTable from '@/components/SortableTable.vue';
import ModalAddNewDealer from '@/components/modals/AddNewDealer.vue';
import ModalConfirmation from '@/components/modals/Confirmation.vue';
import {
  SortableTableDataConfig,
  SortableTableHeader
} from '@/types/SortableTableFormat';
import { cleanupFilterRequest, createFilterRequest } from '@/types/api/FilterRequest';
import debounce from 'debounce';
import Vue from 'vue';
import { ApiResponse } from '@/types/api/Response';
import { AxiosError } from 'axios';
const deleteUserConfirmationTitle = 'Delete Confirmation';
const deleteUserConfirmationMessage = '<p>Are you sure you want to delete this user?</p><p>This action cannot be undone!</p>';
export default Vue.extend({
  'name': 'DealerList',
  'components': {
    SortableTable,
    ModalAddNewDealer,
    ModalConfirmation
  },
  'watch': {
    'tableFilter.search' () {
      this.$nextTick(() => {
        // @ts-expect-error: Ignore warning explicitly.
        this.debounceGetList();
      });
    },
    'pagination.page' () {
      this.$nextTick(() => {
        // @ts-expect-error: Ignore warning explicitly.
        this.debounceGetList();
      });
    }
  },
  data () {
    const pagination = initPagination();
    const form = initForm();
    const tableFilter = initTableSortAndFilter();
    return {
      pagination,
      form,
      tableFilter,
      'tableHeader': [
        {
          'key': 'dealerDetail.dealerType.name',
          'display': 'Type',
          'width': 250,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': 'customId',
          'display': 'ID No.',
          'width': 120,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': 'name',
          'display': 'Name',
          'width': 0,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': 'email',
          'display': 'Email',
          'width': 0,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': 'phone',
          'display': 'Phone No.',
          'width': 180,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': 'createdAt',
          'display': 'Created',
          'width': 140,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        // Phase 1 Issue 4: Last Login column (sortable). Backend returns the field
        // but the legacy view didn't surface it.
        {
          'key': 'lastLogin',
          'display': 'Last Login',
          'width': 160,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': 'isActive',
          'display': 'Status',
          'width': 140,
          'cssClass': 'text-center',
          'isSortable': true,
          'sortOrder': 0,
          'isEmpty': false
        },
        {
          'key': '',
          'display': '',
          'width': 200,
          'cssClass': '',
          'isSortable': false,
          'sortOrder': 0,
          'isEmpty': true
        }
      ] as Array<SortableTableHeader>,
      'tableDataConfigs': [
        {
          'cssClass': 'text-center',
          'hasDisplay': true
        },
        {
          'cssClass': 'text-center',
          'hasDisplay': true
        },
        {
          'cssClass': 'text-center font-weight-bold',
          'hasDisplay': true,
          'clickable': true,
          'event': 'dealerClicked'
        },
        {
          'cssClass': 'text-center',
          'hasDisplay': true
        },
        {
          'cssClass': 'text-center',
          'hasDisplay': true
        },
        {
          'cssClass': 'text-center',
          'hasDisplay': true,
          'isDate': true,
          'dateTimeFormat': 'DD MMM YYYY'
        },
        // Phase 1 Issue 4: lastLogin formatter — show '—' if never logged in
        {
          'cssClass': 'text-center',
          'hasDisplay': true,
          'isDate': true,
          'dateTimeFormat': 'DD MMM YYYY HH:mm',
          'valueFn': (val) => val || null
        },
        {
          'cssClass': 'text-center text-uppercase',
          'hasDisplay': true,
          'classFn': (val) => {
            return (val && val !== 'INACTIVE') ? '' : 'text-danger font-weight-bold';
          }
        },
        {
          'cssClass': 'text-nowrap',
          'hasDisplay': false,
          'buttons': [
            {
              'cssClass': 'btn-iris-table btn-iris-edit',
              'event': 'edit'
            },
            // Phase 1 Issue 4: Reactivate button (relies on admin judgement; the
            // service is idempotent and returns success for already-active dealers).
            {
              'cssClass': 'btn-iris-table btn-iris-reactivate',
              'event': 'reactivate'
            },
            // Phase 1 Issue 5: Branch transfer / close button.
            {
              'cssClass': 'btn-iris-table btn-iris-transfer',
              'event': 'transfer'
            },
            {
              'cssClass': 'btn-iris-table btn-iris-delete',
              'event': 'delete'
            }
          ]
        }
      ] as Array<SortableTableDataConfig>,
      'tableData': [] as Array<DealerListDetailResponse>,
      'debounceGetList': null as unknown,
      // Phase 1 Issue 4
      'statusFilter': '' as string,
      // Phase 1 Issue 5 — Branch transfer modal state
      'transfer': {
        'open': false,
        'sourceId': 0,
        'sourceName': '',
        'targetId': 0,
        'eligible': [] as any[],
        'preview': null as any,
        'submitting': false,
        'error': '' as string
      },
      'deleteUser': {
        'confirmationTitle': deleteUserConfirmationTitle,
        'confirmationMessage': deleteUserConfirmationMessage,
        'showConfirmButton': true,
        'discardButtonText': 'Discard',
        'userId': -1
      }
    };
  },
  mounted () {
    this.debounceGetList = debounce(this.getList, 500);

    this.getList();
  },
  'methods': {
    getList () {
      let getRequest = createFilterRequest(this.pagination, this.tableFilter) as any;
      getRequest = cleanupFilterRequest(getRequest);
      // Phase 1 Issue 4: pass the Status filter through to the backend.
      if (this.statusFilter) getRequest.Status = this.statusFilter;

      this.axios
        .get('dealer/list', {
          'params': getRequest
        })
        .then(({ data }) => {
          const response = data as DealerListResponse;
          this.tableData = response.result.items;

          const paginationUpdate = response.result as Pagination;
          updatePagination(this.pagination, paginationUpdate);
        });
    },
    // ─────────────────────────────────────────────────────────────
    // Phase 1 Issue 4 — Reactivate dealer (admin one-click).
    // POST /dealer/{id}/reactivate
    // ─────────────────────────────────────────────────────────────
    reactivateDealer (rowIndex: number) {
      const dealer = this.tableData[rowIndex];
      if (!dealer) return;
      // Bug fix (Jul 2026): the list API returns isActive as a STRING
      // ('ACTIVE' | 'PENDING' | 'INACTIVE'), not a boolean — so `if (dealer.isActive)`
      // was always truthy and every dealer, including inactive ones, wrongly got
      // "already active". Only 'INACTIVE' dealers are reactivatable.
      if (String(dealer.isActive).toUpperCase() !== 'INACTIVE') {
        alert(`${dealer.name} is already active.`);
        return;
      }
      if (!confirm(`Reactivate ${dealer.name}? They will be able to sign in again.`)) return;
      this.axios.put(`dealer/${dealer.id}/reactivate`)
        .then(() => { this.getList(); })
        .catch((e: any) => { alert(e?.response?.data?.message || 'Reactivation failed.'); });
    },
    // ─────────────────────────────────────────────────────────────
    // Phase 1 Issue 5 — Branch close + customer bulk-transfer.
    // ─────────────────────────────────────────────────────────────
    openTransfer (rowIndex: number) {
      const dealer = this.tableData[rowIndex];
      if (!dealer) return;
      this.transfer.open = true;
      this.transfer.sourceId = dealer.id;
      this.transfer.sourceName = dealer.name;
      this.transfer.targetId = 0;
      this.transfer.preview = null;
      this.transfer.error = '';
      // Eligible targets = all other dealers (excluding the source)
      this.transfer.eligible = this.tableData
        .filter((d: any) => d.id !== dealer.id && d.isActive)
        .map((d: any) => ({ 'id': d.id, 'name': d.name, 'email': d.email }));
    },
    closeTransfer () {
      this.transfer.open = false;
    },
    loadPreview () {
      if (!this.transfer.targetId) {
        this.transfer.preview = null;
        return;
      }
      this.transfer.error = '';
      this.axios.get(`dealer/${this.transfer.sourceId}/transfer-preview`, {
        'params': { 'targetDealerId': this.transfer.targetId }
      })
        .then((res: any) => { this.transfer.preview = res.data.result; })
        .catch((e: any) => { this.transfer.error = e?.response?.data?.message || 'Preview failed.'; });
    },
    confirmTransfer () {
      const target = this.transfer.eligible.find((d: any) => d.id === this.transfer.targetId);
      if (!target) return;
      if (!confirm(`Transfer ${this.transfer.preview.customerCount} customers from ${this.transfer.sourceName} to ${target.name}? An email will be sent to each.`)) return;
      this.transfer.submitting = true;
      this.transfer.error = '';
      this.axios.put(`dealer/${this.transfer.sourceId}/transfer`, { 'targetDealerId': this.transfer.targetId })
        .then((res: any) => {
          alert(`Transferred ${res.data.result.transferred} customer(s).`);
          this.transfer.open = false;
          this.getList();
        })
        .catch((e: any) => { this.transfer.error = e?.response?.data?.message || 'Transfer failed.'; })
        .finally(() => { this.transfer.submitting = false; });
    },
    addDealer () {
      resetForm(this.form);
      (this.$refs.modalAddNewDealer as any).create();
    },
    editDealer (rowIndex: number) {
      const dealerId = this.tableData[rowIndex].id;

      this.axios.get(`dealer/${dealerId}`).then(({ data }) => {
        const response = data as DealerResponse;

        updateForm(this.form, response.result);

        (this.$refs.modalAddNewDealer as any).update();
      });
    },
    deleteDealer (rowIndex: number) {
      this.deleteUser.userId = this.tableData[rowIndex]
        ? this.tableData[rowIndex].id
        : 0;

      this.deleteUser.confirmationTitle = deleteUserConfirmationTitle;
      this.deleteUser.confirmationMessage = deleteUserConfirmationMessage;
      this.deleteUser.showConfirmButton = true;
      this.deleteUser.discardButtonText = 'Discard';
      (this.$refs.deleteUserConfirmation as any).show();
    },
    confirmDeleteUser () {
      (this.$refs.deleteUserConfirmation as any).hide(() => {
        this.axios.delete(`dealer/${this.deleteUser.userId}`).then(({ data }) => {
          this.getList();

          this.deleteUser.confirmationTitle = 'Success';
          this.deleteUser.confirmationMessage = data.message;
          this.deleteUser.showConfirmButton = false;
          this.deleteUser.discardButtonText = 'Dismiss';
        }).catch((err:AxiosError) => {
          this.deleteUser.confirmationTitle = 'Error';
          if (err && err.response) {
            const data = err.response.data as ApiResponse;
            this.deleteUser.confirmationMessage = data.message;
          }
          this.deleteUser.showConfirmButton = false;
          this.deleteUser.discardButtonText = 'Dismiss';
        }).finally(() => {
          (this.$refs.deleteUserConfirmation as any).show();
        });
      });
    },
    discardDeleteUser () {
      (this.$refs.deleteUserConfirmation as any).hide();
    },
    submitForm () {
      if (this.form.dealerId === 0) {
        this.form.isSubmitting = true;
        const clonedForm = Object.assign({}, this.form);
        delete clonedForm.dealerId;
        this.axios
          .post('dealer', clonedForm)
          .then(() => {
            (this.$refs.modalAddNewDealer as any).hide();
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.status === 422 &&
              err.response.data
            ) {
              const result = err.response.data.result;
              if (result) {
                (this.$refs.modalAddNewDealer as any).setErrors(result);
              }
            }
          })
          .finally(() => {
            this.form.isSubmitting = false;
            this.getList();
          });
      } else {
        this.form.isSubmitting = true;
        this.axios
          .put('dealer', this.form)
          .then(() => {
            (this.$refs.modalAddNewDealer as any).hide();
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.status === 422 &&
              err.response.data
            ) {
              const result = err.response.data.result;
              if (result) {
                (this.$refs.modalAddNewDealer as any).setErrors(result);
              }
            }
          })
          .finally(() => {
            this.form.isSubmitting = false;
            this.getList();
          });
      }
    },
    viewDealer (row: number) {
      const dealer = this.tableData[row];

      this.$store.commit('updateViewDealerId', dealer.id);
      this.$router.push({
        'name': 'AdminDealerStockList'
      });
    },
    updateTableSort (tableSort: TableSortAndFilter) {
      updateTableSort(this.tableFilter, tableSort);
      this.getList();
    },
    exportAll () {
      this.axios({
        'url': 'Dealer/export',
        'method': 'GET',
        'responseType': 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'dealers.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
  }
});
